/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExpertServiceApiResponse } from '../models/ExpertServiceApiResponse';
import type { ModeApiResponse } from '../models/ModeApiResponse';
import type { ServiceApiResponse } from '../models/ServiceApiResponse';
import type { ServiceTypeApiResponse } from '../models/ServiceTypeApiResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MasterApiService {
    /**
     * Get all session delivery modes
     * Returns the available session delivery modes (online, at client location, at expert location).
     * @returns ModeApiResponse Modes fetched successfully
     * @throws ApiError
     */
    public static masterApiControllerGetModesV1(): CancelablePromise<ModeApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/master/modes',
        });
    }
    /**
     * Get all expert service types
     * Returns the list of top-level expert service types (e.g. Personal Trainers, Psychologists, Physiotherapists, Trained Listeners) used for the Browse Services section.
     * @returns ServiceTypeApiResponse Service types fetched successfully
     * @throws ApiError
     */
    public static masterApiControllerGetServiceTypesV1(): CancelablePromise<ServiceTypeApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/master/service-types',
        });
    }
    /**
     * Get all services
     * Returns all active services (sub-services) across the platform, grouped by their parent service types. Used for the Services tab to render cards like Weight Training, Clinical Therapy, etc.
     * @returns ServiceApiResponse Services fetched successfully
     * @throws ApiError
     */
    public static masterApiControllerGetAllServicesV1(): CancelablePromise<ServiceApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/master/services',
        });
    }
    /**
     * Get all services for an expert
     * Returns all active expert_service mappings for the given expert, including the service type and sub-service names.
     * @param expertId Expert UUID
     * @returns ExpertServiceApiResponse Expert services fetched successfully
     * @throws ApiError
     */
    public static masterApiControllerGetExpertServicesV1(
        expertId: string,
    ): CancelablePromise<ExpertServiceApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/master/experts/{expertId}/services',
            path: {
                'expertId': expertId,
            },
            errors: {
                404: `Expert not found`,
            },
        });
    }
}
